/**
 * DR-3275 — the per-document status contract.
 *
 * One snapshot per `(reconstructedDocumentId, family)`, replace-set semantics: the
 * snapshot IS the entity's current truth for that family, never a delta. The store is
 * authoritative and keeps full history indefinitely; the `status-snapshot-ready` webhook
 * is a nudge only (ids + family + generation), so a consumer that missed a nudge catches
 * up through `GET /api/status-snapshots?cursor=<nextCursor>` instead of losing data.
 *
 * Deliberately NOT the merged project-level `*-events-ready` payloads: those consolidate
 * across documents (revision-lane collapse, winning-document pick, cross-document dedupe)
 * and drop rows a per-report compliance view needs to see. A snapshot is "as extracted"
 * for exactly one entity — crossed-out rows stay, with their flag forwarded.
 */
export const STATUS_SNAPSHOT_CONTRACT_VERSION = 1;
/** The families carried by the per-document contract. */
export const STATUS_SNAPSHOT_FAMILIES = ['ad', 'sb', 'ldnd', 'qec', 'llp'];
/**
 * - `ready` — extraction finished and produced at least one row.
 * - `no-data` — extraction finished and produced no rows. Explicit rather than absent so
 *   the consumer can tell "this document genuinely has no AD rows" from "not extracted yet".
 * - `failed` — entity extraction ended in error. `events` still carries whatever the pages
 *   that DID succeed produced: a partial AD status is worth more to a compliance reviewer
 *   than nothing, as long as the state says not to treat it as complete.
 * - `retracted` — tombstone; `events` is empty. The entity was unlinked, regrouped, deleted,
 *   or re-categorised away from this family, so the previously published rows no longer apply.
 */
export const STATUS_SNAPSHOT_STATES = ['ready', 'no-data', 'failed', 'retracted'];
//# sourceMappingURL=document-status-snapshot.schema.js.map